import type { DropdownData, FormField } from '@fitogest/reactive-form-builder/interfaces';
import { list } from '@fitogest/reactive-form-builder/utils';
import { AnalisisModel } from 'src/app/models/analisis/analisis.model';
import { ComunidadesRegantesModel } from 'src/app/models/analisis/comunidadesRegantes.model';
import { ClienteModel } from 'src/app/models/cliente.model';
import { FincasModel } from 'src/app/models/form-common/fincas.module';
import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { SectorModel } from 'src/app/models/form-common/sector.model';

export class AnalisisListsDefinition {
    public tiposAnalisis: DropdownData<string> = list<string>(
        ['...', null],
        'Agua - Microbiológico',
        'Agua - Químico',
        'Foliar',
        'Fruta - Clementina',
        'Fruta - Fresón',
        'Fruta - Mandarina',
        'Fruta - Naranja',
        'Fruta - Satsuma',
        'Residuos',
        'Savia',
        'Solución nutritiva',
        'Suelo'
    );

    public tiposAnalisisViverogest: DropdownData<string> = list<string>(
        ['...', null],
        'Agua - Microbiológico',
        'Agua - Químico',
        'Foliar',
        'Fruta - Clementina',
        'Fruta - Fresón',
        'Fruta - Mandarina',
        'Fruta - Naranja',
        'Fruta - Satsuma',
        'Residuos',
        'Savia',
        'Solución nutritiva',
        'Suelo',
        'Suelo - pH',
        'Suelo - Conductividad',
        'Suelo - Nitratos',
        'Suelo - Sulfatos'
    );

    public tiposAnalisisCovidai: DropdownData<string> = list<string>(
        ['...', null],
        'Agua - Microbiológico',
        'Agua - Químico',
        'Foliar',
        'Planta Hongo',
        'Planta Virus',
        'Planta Bacterias',
        'Residuos',
        'Savia',
        'Solución nutritiva',
        'Suelo'
    );

    public tiposAnalisisTp: DropdownData<string> = list<string>(
        ['...', null],
        'Agua - Microbiológico',
        'Agua - Químico',
        'Foliar',
        'Fruta - Clementina',
        'Fruta - Fresón',
        'Fruta - Mandarina',
        'Fruta - Naranja',
        'Fruta - Satsuma',
        'Residuos',
        'Savia',
        'Solución nutritiva',
        'Suelo',
        'Suelo - nematodos'
    );

    public tiposAnalisisFast: DropdownData<string> = list<string>(
        ['...', null],
        'Agua',
        'Hoja',
        'Nematodos',
        'Suelo'
    );

    public tiposAnalisisArmentia: DropdownData<string> = list<string>(
        ['...', null],
        'Agua',
        'Planta',
        'Residuos',
        'Suelo'
    );

    public tiposAnalisisEsparragos: DropdownData<string> = list<string>(
        ['...', null],
        'Agua - Microbiológico',
        'Agua - Químico',
        'Producto - Microbiológico',
        'Producto - Multirresiduos',
        'Producto - Metales pesados',
        'Producto - Mercurio',
        'Producto - Amonios cuaternarios',
        'Producto - Fosfonatos',
        'Producto - Fosetil AI',
        'Producto - Cloratos y percloratos'
    );

    public frecuenciasFast: DropdownData<string> = list<string>('1 año');
    public frecuenciasArmentia: DropdownData<string> = list<string>(['...', null], '1 año', '2 años', '3 años');
    public frecuenciasEsparragos: DropdownData<string> = list<string>('Semanal');

    public formFieldsDatosSuelo: FormField<AnalisisModel>[] = [];

    public analisis: AnalisisModel = new AnalisisModel;
    public clientes: DropdownData<ClienteModel> = list();
    public fincas: DropdownData<FincasModel> = list();
    public parcelas: DropdownData<ParcelasModel> = list();
    public frecuencias: DropdownData<string> = list(
        ['...', null],
        '1 mes',
        '2 meses',
        '3 meses',
        '4 meses',
        '6 meses',
        '1 año',
        '2 años',
        '3 años',
        '4 años',
        '5 años'
    );
    public lista_analisis: DropdownData<string> = list(
        ['...', null],
        'Control rutinario',
        'Programas de vigilancia',
        'Otros'
    );

    public frecuenciasSuelo: DropdownData<string> = list(
        ['...', null],
        '3 años',
        '4 años',
        '5 años',
    );
    public frecuenciasFoliar: DropdownData<string> = list(
        ['...', null],
        '1 año',
        '2 años'
    );
    public frecuenciasFruta: DropdownData<string> = list(
        ['...', null],
        '1 mes',
        '2 meses',
        '3 meses',
        '4 meses',
        '6 meses',
        '1 año',
        '2 años',
        '3 años',
        '4 años',
        '5 años'
    );
    public frecuenciasAguaM: DropdownData<string> = list(
        ['...', null],
        '1 mes',
        '2 meses',
        '3 meses',
        '4 meses',
        '1 año'
    );
    public frecuenciasAguaQ: DropdownData<string> = list(
        ['...', null],
        '1 año',
        '2 años',
        '3 años'
    );
    public frecuenciasFreson: DropdownData<string> = list(['...', null], '1 mes');
    public frecuenciasResiduos: DropdownData<string> = list(
        ['...', null],
        'Quincena',
        '1 año'
    );
    public frecuenciasSavia: DropdownData<string> = list(['...', null], '1 mes');

    public estados: DropdownData<string> = list(
        'Programada',
        'Solicitada',
        'Realizada'
    );

    public showExtraFields = false;

    public sectores: DropdownData<SectorModel> = list();
    public lista_parcelas: DropdownData<ParcelasModel> = list();

    public comunidadesRegantes: DropdownData<ComunidadesRegantesModel> = list();
}